import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const OrderedList = forwardRef<
  HTMLOListElement,
  React.HTMLProps<HTMLOListElement>
>((props, ref) => {
  const { className, ...rest } = props;

  return (
    // @ts-expect-error - something wrong with forwardRef typing
    <ol
      ref={ref}
      {...rest}
      className={twMerge("ml-8 list-inside", className)}
    />
  );
});
